<mat-sidenav-container class="h-full">
  <mat-sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="!isMobile()" #sidenav>
    <!-- Sidebar -->
    <sidebar>
      <!-- Header -->
      <sidebar-header class="pb-3">
        @if (isHomePage()) {
          <div class="flex items-center cursor-default select-none">
            @if (logoUrl()) {
              <img class="-ml-0.5 size-7" [src]="logoUrl()" [alt]="appName() || 'Logo'" />
            }
            @if (appName()) {
              <div class="ml-3 text-2xl font-bold">{{ appName() }}</div>
            }
            @if (hasProBadge()) {
              <span
                class="ml-2 rounded-md border border-primary-5 bg-primary-a3 px-1.5 py-0.5 text-[11px] font-semibold tracking-wide text-primary-11"
              >
                {{ effectiveBadge() }}
              </span>
            }
          </div>
        } @else {
          <a [routerLink]="homeUrl()" class="flex items-center cursor-pointer select-none">
            @if (logoUrl()) {
              <img class="-ml-0.5 size-7" [src]="logoUrl()" [alt]="appName() || 'Logo'" />
            }
            @if (appName()) {
              <div class="ml-3 text-2xl font-bold">{{ appName() }}</div>
            }
            @if (hasProBadge()) {
              <span
                class="ml-2 rounded-md border border-primary-5 bg-primary-a3 px-1.5 py-0.5 text-[11px] font-semibold tracking-wide text-primary-11"
              >
                {{ effectiveBadge() }}
              </span>
            }
          </a>
        }
      </sidebar-header>

      @if (showExploreButton()) {
        <div class="px-6 py-4 relative z-10">
          <aura-glowing-gradient-button routerLink="/explore" label="Explorer" icon="compass" />
        </div>
      }

      <!-- Body -->
      <sidebar-body>
        <sidebar-section>
          <sidebar-section-content>
            <sidebar-menu>
              @for (item of navigationItems(); track item.id) {
                @if (item.type === 'basic') {
                  <sidebar-menu-item>
                    <a [routerLink]="item.link" routerLinkActive="active">
                      <sidebar-icon [icon]="item.icon!" />
                      <sidebar-label>{{ item.label }}</sidebar-label>
                      <!--
                      <sidebar-badge>3</sidebar-badge>
                      -->
                    </a>
                  </sidebar-menu-item>
                }
              }
            </sidebar-menu>
          </sidebar-section-content>
        </sidebar-section>

        <collapsible [expanded]="true">
          <sidebar-section>
            @for (item of navigationItems(); track item.id) {
              @if (item.type === 'collapsable') {
                <collapsible-trigger>
                  <sidebar-section-header>
                    <button>
                      <sidebar-label class="grow-0">{{ item.label }}</sidebar-label>
                      <sidebar-icon
                        class="size-4 group-data-expanded/collapsible:rotate-90"
                        icon="chevron-right"
                      />
                    </button>
                  </sidebar-section-header>
                </collapsible-trigger>

                <collapsible-content>
                  <sidebar-section-content>
                    <sidebar-menu>
                      @for (child of item.children; track $index) {
                        @if (child.type === 'basic') {
                          <sidebar-menu-item>
                            <a [routerLink]="child.link" routerLinkActive="active">
                              <sidebar-icon [icon]="child.icon!" />
                              <sidebar-label>{{ child.label }}</sidebar-label>
                            </a>
                          </sidebar-menu-item>
                        }
                        @if (child.type === 'collapsable') {
                          <collapsible [expanded]="child.expanded !== false" #subCollapsible>
                            <sidebar-menu-item>
                              <button collapsibleTrigger>
                                <sidebar-icon
                                  [icon]="subCollapsible.expanded() ? 'folder-open' : child.icon || 'folder'"
                                />
                                <sidebar-label>{{ child.label }}</sidebar-label>
                              </button>
                            </sidebar-menu-item>
                            <collapsible-content>
                              <sidebar-menu>
                                @for (subChild of child.children; track subChild.id) {
                                  @if (subChild.type === 'basic') {
                                    <sidebar-menu-item>
                                      <a [routerLink]="subChild.link" routerLinkActive="active">
                                        <sidebar-icon [icon]="subChild.icon!" />
                                        <sidebar-label>{{ subChild.label }}</sidebar-label>
                                      </a>
                                    </sidebar-menu-item>
                                  }
                                }
                              </sidebar-menu>
                            </collapsible-content>
                          </collapsible>
                        }
                      }
                    </sidebar-menu>
                  </sidebar-section-content>
                </collapsible-content>
              }
            }
          </sidebar-section>
        </collapsible>
        <!--
        <collapsible [expanded]="true">
          <sidebar-section>
            <sidebar-section-header>
              <button collapsibleTrigger>
                <sidebar-label class="grow-0">Favorites</sidebar-label>
                <sidebar-icon class="size-4 group-data-expanded/collapsible:rotate-90" icon="chevron-right" />
              </button>
              <sidebar-action class="opacity-0 group-hover/sidebar-section-header:opacity-100">
                <sidebar-icon icon="folder-plus" />
              </sidebar-action>
            </sidebar-section-header>

            <collapsible-content>
              <sidebar-section-content>
                <sidebar-menu>
                  <collapsible [expanded]="true" #collapsible>
                    <sidebar-menu-item>
                      <button collapsibleTrigger>
                        <sidebar-icon [icon]="collapsible.expanded() ? 'folder-open' : 'folder'" />
                        <sidebar-label>Projects</sidebar-label>
                      </button>
                      <sidebar-action
                        class="opacity-0 group-hover/sidebar-menu-item:opacity-100"
                        [class.opacity-100]="trigger.menuOpen"
                        [attr.data-sidebar-menu-item-active]="trigger.menuOpen ? true : null"
                        [matMenuTriggerFor]="folderActions"
                        #trigger="matMenuTrigger"
                      >
                        <sidebar-icon icon="ellipsis" />
                        <mat-menu #folderActions>
                          <button mat-menu-item>
                            <mat-icon svgIcon="folder-pen" />
                            Rename
                          </button>
                          <mat-divider />
                          <button mat-menu-item>
                            <mat-icon svgIcon="x" />
                            Remove folder
                          </button>
                        </mat-menu>
                      </sidebar-action>
                    </sidebar-menu-item>
                    <collapsible-content>
                      <sidebar-menu>
                        <sidebar-menu-item>
                          <a>
                            <sidebar-icon icon="box" />
                            <sidebar-label>Spark</sidebar-label>
                          </a>
                          <sidebar-action class="opacity-0 group-hover/sidebar-menu-item:opacity-100">
                            <sidebar-icon icon="x" />
                          </sidebar-action>
                        </sidebar-menu-item>
                        <sidebar-menu-item>
                          <a>
                            <sidebar-icon icon="box" />
                            <sidebar-label>Horizon</sidebar-label>
                          </a>
                          <sidebar-action class="opacity-0 group-hover/sidebar-menu-item:opacity-100">
                            <sidebar-icon icon="x" />
                          </sidebar-action>
                        </sidebar-menu-item>
                        <sidebar-menu-item>
                          <a>
                            <sidebar-icon icon="box" />
                            <sidebar-label>Pulse</sidebar-label>
                          </a>
                          <sidebar-action class="opacity-0 group-hover/sidebar-menu-item:opacity-100">
                            <sidebar-icon icon="x" />
                          </sidebar-action>
                        </sidebar-menu-item>
                      </sidebar-menu>
                    </collapsible-content>
                  </collapsible>

                  <sidebar-menu-item>
                    <a>
                      <sidebar-icon icon="star" />
                      <sidebar-label>All issues</sidebar-label>
                    </a>
                    <sidebar-action class="opacity-0 group-hover/sidebar-menu-item:opacity-100">
                      <sidebar-icon icon="x" />
                    </sidebar-action>
                  </sidebar-menu-item>
                  <sidebar-menu-item>
                    <a>
                      <sidebar-icon icon="star" />
                      <sidebar-label>All tasks</sidebar-label>
                    </a>
                    <sidebar-action class="opacity-0 group-hover/sidebar-menu-item:opacity-100">
                      <sidebar-icon icon="x" />
                    </sidebar-action>
                  </sidebar-menu-item>
                </sidebar-menu>
              </sidebar-section-content>
            </collapsible-content>
          </sidebar-section>
        </collapsible>
-->
        <!-- Trial 
        <div class="flex flex-col gap-y-2 px-6 pb-6">
          
          <div class="rounded-md bg-neutral-a3 p-4">
            <span class="text-lg font-semibold">Trial expires soon</span>
            <p class="mt-2 text-sm">Only 3 days left! Upgrade for unlimited access.</p>
            <button
              matButton
              class="small mt-4 w-full"
            >
              Upgrade now
            </button>
          </div>
        </div>-->
      </sidebar-body>

      <sidebar-divider />

      <sidebar-footer class="flex flex-col gap-y-2">
        @if (user(); as user) {
          <aura-sidebar-user
            [user]="user"
            [scheme]="theming.scheme()"
            (schemeChanged)="updateScheme($event)"
          />
        }
      </sidebar-footer>
    </sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="flex flex-col h-full overflow-hidden">
    <aura-impersonate-banner />
    <div class="surface-default flex items-center justify-between gap-x-4 border-b p-4">
      <button matIconButton (click)="sidenav.toggle()">
        <mat-icon svgIcon="panel-left" />
      </button>

      <div class="flex items-center gap-x-2">
        <aura-profile-app-switcher [user]="user()" />
        @if (user()) {
          <aura-notifications-dropdown
            [notifications]="notifications()"
            [unreadCount]="unreadCount()"
            (markAsRead)="markAsRead($event)"
            (markAllAsRead)="markAllAsRead()"
            (viewAll)="goToNotifications()"
          />
          <aura-discussions-button />
        }
        @if (isAdminApp()) {
          <aura-apps-menu-button />
        }
      </div>
    </div>

    <!-- Content -->

    <div class="flex flex-1 min-h-0 overflow-y-auto">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
